import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatTabsModule } from '@angular/material/tabs';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { ScholarshipDetails } from '../../classes/scholarship-details';
import { AppService } from '../../services/app.service';
import { SnackBarService } from '@polk_county_public_schools/ngx-pcps-dialogs/snackbar';
import { UserInfo, UserService } from '../../services/user.service';
import { SchoolYearPipe } from '../../pipes/schoolyear/schoolyear.pipe';
import { ErrorService } from '../../services/error.service';

@Component({
    selector: 'app-scholarship-details',
    templateUrl: './scholarship-details.component.html',
    imports: [
        MatCardModule,
        MatTabsModule,
        SchoolYearPipe,
        MatDividerModule,
        MatButtonModule,
        RouterModule
    ]
})
export class ScholarshipDetailsComponent implements OnInit {
    protected readonly destroyRef = inject(DestroyRef);
    protected readonly appSvc = inject(AppService);
    protected readonly route = inject(ActivatedRoute);
    protected readonly snackBarSvc = inject(SnackBarService);
    protected readonly userSvc = inject(UserService);
    protected readonly errorSvc = inject(ErrorService);
    user: UserInfo;
    masterID: number;
    details: ScholarshipDetails;

    ngOnInit() {
        this.user = this.userSvc.User;
        this.route.params.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(params => {
            this.masterID = +params['id'];
            this.getScholarshipDetails();
        });

    }

    getScholarshipDetails() {
        this.appSvc.GetScholarshipDetails(this.masterID).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
            next: res => {
                this.details = res;
            }, error: error => {
                this.errorSvc.HandleServiceError(error);
            }
        });
    }
}
